export function Newsletter() {
    // 👇️ redirect to external URL
    window.location.replace('https://mailchi.mp/044223217bcb/pcdcoimbra2022');
    return null;
}